import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export type Crumb = { label: string; to?: string };

/** Where am I: Org › Project › Tab. The last crumb is the current page. */
export function Breadcrumb({ label, items, className }: { label: string; items: Crumb[]; className?: string }) {
  if (items.length === 0) return null;
  return (
    <nav aria-label={label} className={cn("min-w-0", className)}>
      <ol className="flex min-w-0 items-center gap-1 text-sm">
        {items.map((item, i) => {
          const last = i === items.length - 1;
          return (
            <li key={`${item.label}-${i}`} className={cn("flex min-w-0 items-center gap-1", i < items.length - 2 && "hidden sm:flex")}>
              {item.to && !last ? (
                <Link to={item.to} className="truncate text-fg-muted no-underline hover:text-heading hover:underline">
                  {item.label}
                </Link>
              ) : (
                <span aria-current={last ? "page" : undefined} className="truncate font-semibold text-heading">
                  {item.label}
                </span>
              )}
              {!last ? <ChevronRight aria-hidden="true" className="h-4 w-4 shrink-0 text-fg-subtle" /> : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
